"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var CenteredMessage_1 = require("../CenteredMessage");
var LayoutComponents_1 = require("../style/LayoutComponents");
var StyleFunctions_1 = require("../style/StyleFunctions");
var emptyGridContainerClass = StyleFunctions_1.cssClass('emptyGridContainer', {
    height: '100%'
});
function EmptyGridElement(props) {
    return (React.createElement(LayoutComponents_1.HorizontalFlexContainer, { additionalClassNames: [emptyGridContainerClass] },
        React.createElement(CenteredMessage_1.CenteredMessage, { message: props.emptyGridMessage || Localize_1.Messages.EmptyContentMessage() })));
}
exports.EmptyGridElement = EmptyGridElement;
//# sourceMappingURL=EmptyGridElement.js.map